// extracted by mini-css-extract-plugin
export default {"actions":"StudioMobile_actions__Y5gXW"};